import {
  ProseA,
  ProseAccordion,
  ProseAccordionItem,
  ProseBadge,
  ProseBlockquote,
  ProseCallout,
  ProseCard,
  ProseCardGroup,
  ProseCaution,
  ProseCode,
  ProseCodeCollapse,
  ProseCodeGroup,
  ProseCodeIcon,
  ProseCodePreview,
  ProseCodeTree,
  ProseCollapsible,
  ProseEm,
  ProseField,
  ProseFieldGroup,
  ProseH1,
  ProseH2,
  ProseH3,
  ProseH4,
  ProseHr,
  ProseIcon,
  ProseImg,
  ProseKbd,
  ProseLi,
  ProseNote,
  ProseOl,
  ProseP,
  ProsePre,
  ProsePrompt,
  ProseScript,
  ProseSteps,
  ProseStrong,
  ProseTable,
  ProseTabs,
  ProseTabsItem,
  ProseTbody,
  ProseTd,
  ProseTh,
  ProseThead,
  ProseTip,
  ProseTr,
  ProseUl,
  ProseWarning
} from '#components'

/**
 * Nuxt UI prose components, resolved eagerly with the page instead of the global async components.
 *
 * Override one with its `Prose*` key: comark resolves `ProseImg` before `img`.
 */
export const proseComponents = {
  ProseA,
  ProseAccordion,
  ProseAccordionItem,
  ProseBadge,
  ProseBlockquote,
  ProseCallout,
  ProseCard,
  ProseCardGroup,
  ProseCaution,
  ProseCode,
  ProseCodeCollapse,
  ProseCodeGroup,
  ProseCodeIcon,
  ProseCodePreview,
  ProseCodeTree,
  ProseCollapsible,
  ProseEm,
  ProseField,
  ProseFieldGroup,
  ProseH1,
  ProseH2,
  ProseH3,
  ProseH4,
  ProseHr,
  ProseIcon,
  ProseImg,
  ProseKbd,
  ProseLi,
  ProseNote,
  ProseOl,
  ProseP,
  ProsePre,
  ProsePrompt,
  ProseScript,
  ProseSteps,
  ProseStrong,
  ProseTable,
  ProseTabs,
  ProseTabsItem,
  ProseTbody,
  ProseTd,
  ProseTh,
  ProseThead,
  ProseTip,
  ProseTr,
  ProseUl,
  ProseWarning
}
